import { CSSProperties, HTMLAttributes, ReactElement, ReactNode } from 'react';

type Props = {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  children?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export const Centered = ({ children, width, height, ...restProps }: Props): ReactElement => (
  <div
    {...restProps}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width,
      height,
      ...restProps.style,
    }}
  >
    {children}
  </div>
);
